export const formatCurrency = (currency: any): any => {
	return new Intl.NumberFormat('en-US', {
		currency: 'USD',
		style: 'currency',
		maximumFractionDigits: 0,
	}).format(isNaN(currency) ? 0 : currency);
};
